import numAbbr from "number-abbreviate";

export function abbreviateNumber(num: number) {
    if (!num) {
        return 0;
    }

    const newNum = numAbbr(num, 1);
    if (typeof newNum === "string") {
        return newNum.toUpperCase();
    }
    return newNum;
}
